"use client";
const ActionButtons = ({
  handleDownload,
  onClickClose,
}: {
  handleDownload: () => void;
  onClickClose: () => void;
}) => {
  return (
    <div className="flex flex-col w-full justify-center mt-5 text-base leading-6 max-md:max-w-full">
      <div className="flex gap-3 max-md:flex-wrap max-md:max-w-full">
        <button
          onClick={handleDownload}
          className="flex justify-center items-center px-5 py-2.5 font-medium bg-lime-300 rounded-lg shadow-sm text-neutral-800 max-md:px-5 w-full"
        >
          تحميل
        </button>
        <button
          onClick={onClickClose}
          className="flex justify-center items-center px-5 py-2.5 text-white rounded-lg shadow-sm bg-neutral-600 max-md:px-5 w-full"
        >
          الغاء
        </button>
      </div>
    </div>
  );
};

export default ActionButtons;
